<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="3"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.foreignCompanyData.managerIdentityType"
          :value.sync="formModel.manager.identityTypeId"
          :items="identityTypes"
          item-text="name"
          item-value="id"
          :disabled="isViewMode || isEditMode"
          validates="required"
          @change="identityTypeChanged"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        md="3"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="locale.partners.identityNumber"
          :value.sync="formModel.manager.identityNumber"
          :disabled="isViewMode || !formModel.manager.identityTypeId || isEditMode"
          :maxlength="50"
          :validates="socialIdRules"
          @input="identityNumberChanged"
        ></naj-input>
      </v-col>

      <v-col
        cols="12"
        md="3"
        lg="3"
      >
        <naj-input
          v-if="!isNationalIdOrIqama"
          :type-id="formFieldType.selectbox"
          :label="local.bankruptcy.requestApplicant.nationality"
          :value.sync="formModel.manager.nationality"
          :items="nationalities"
          item-text="name"
          item-value="id"
          :disabled="isViewMode || validating || !formModel.manager.identityTypeId || isEditMode"
        ></naj-input>
      </v-col>

      <v-col
        v-if="isOtherIdType && !isViewMode"
        cols="12"
        md="3"
        lg="3"
        class="d-flex align-center"
      >
        <naj-button
          square
          inputs-alignment
          :loading="false"
          :disabled="!formModel.manager.identityNumber || formModel.manager.isIdentityVerified || validating"
          @click="validateViaBankruptcy"
        >
          <v-icon
            v-if="validating"
            class="manager-btn-loading"
            size="20"
          >
            mdi-loading
          </v-icon>
          {{ local.bankruptcy.identityVerificationForm.validateIdentityNumber }}
        </naj-button>
      </v-col>
    </v-row>

    <v-row v-if="isNationalIdOrIqama">
      <v-col
        cols="12"
        md="12"
        lg="6"
      >
        <naj-input
          :form-key="managerFormKey"
          :type-id="formFieldType.date"
          :label="local.bankruptcy.identityVerificationForm.dateOfBirth"
          :value.sync="formModel.manager.dateOfBirth"
          :disabled="isViewMode || validating || formModel.manager.isIdentityVerified || !formModel.manager.identityTypeId || isEditMode"
        ></naj-input>
      </v-col>
      <v-col
        v-if="!isViewMode && !formModel.manager.isIdentityVerified"
        cols="12"
        md="6"
        lg="4"
        class="d-flex align-center flex-nowrap"
      >
        <naj-button
          square
          inputs-alignment
          :loading="false"
          :disabled="!formModel.manager.identityNumber || (!formModel.manager.dateOfBirth && !formModel.manager.firstName) || validating"
          @click="validateViaMoi"
        >
          <v-icon
            v-if="validating"
            class="manager-btn-loading"
            size="20"
          >
            mdi-loading
          </v-icon>
          {{ local.bankruptcy.identityVerificationForm.validateIdentityNumber }}
        </naj-button>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              large
              v-bind="attrs"
              v-on="on"
            >
              mdi-information
            </v-icon>
          </template>
          <span>{{ local.bankruptcy.identityVerificationForm.personVerify }}</span>
        </v-tooltip>
      </v-col>
    </v-row>



    <v-row v-if="isPassport">
      <v-col
        cols="12"
        md="6"
        lg="6"
      >
        <naj-input
          :type-id="formFieldType.date"
          :label="local.personInformation.passportDate"
          :value.sync="formModel.manager.passportDate"
          :disabled="isViewMode || validating || !formModel.manager.identityTypeId || isEditMode"
          :validates="`required`"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        md="3"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.personInformation.passportSource"
          :value.sync="formModel.manager.passportSource"
          :disabled="isViewMode || validating || !formModel.manager.identityTypeId || isEditMode"
          :maxlength="50"
          validates="required|max:50"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row v-if="isOtherIdType && formModel.manager.isIdentityVerified && formModel.manager.isNameFromSystem">
      <v-col
        cols="12"
        md="6"
        lg="4"
      >
        <v-checkbox
          v-model="formModel.manager.isNameDifferent"
          :label="local.foreignCompanyData.nameIsDifferent"
          :disabled="isViewMode || isEditMode"
          hide-details
          @change="nameDifferentChanged"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.bankruptcy.requestApplicant.firstName"
          :value.sync="formModel.manager.firstName"
          :disabled="nameFieldsDisabled"
          validates="required"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.personInformation.fatherName"
          :value.sync="formModel.manager.fatherName"
          :disabled="nameFieldsDisabled"
          validates="required"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.personInformation.grandFatherName"
          :value.sync="formModel.manager.thirdName"
          :disabled="nameFieldsDisabled"
          validates="required"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.personInformation.familyName"
          :value.sync="formModel.manager.familyName"
          :disabled="nameFieldsDisabled"
          validates="required"
        ></naj-input>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapActions, mapState: mapLUTState } = createNamespacedHelpers('BankruptcyModule');
const { mapActions: mapSysActions } = createNamespacedHelpers('SystemModule');
import { uuidGenerator } from '@/helpers/utils';
import { managerIdentityTypeEnum } from '@/modules/bankruptcy/helpers/enum';
import { socialIdentityTypeEnum } from '@/helpers/enum';

export default {
  inject: ['$validator'],
  props: {
    formModel: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    isEditMode: {
      type: Boolean,
      required: false,
    },
    isViewMode: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      locale: this.local.bankruptcy.requestDetails,
      managerIdentityTypeEnum,
      identityTypes: Object.keys(managerIdentityTypeEnum)
        .map(pt => ({
          id: managerIdentityTypeEnum[pt],
          name: this.local.bankruptcy.common[pt],
        })),
      validating: false,
      socialIdentityTypeEnum,
      nationalities: [],
      managerFormKey: uuidGenerator(),
    };
  },
  computed: {
    ...mapGetters(['isNewMode', 'isNotCompleted']),
    ...mapLUTState(['countries']),
    isPassport() {
      return this.formModel.manager.identityTypeId == managerIdentityTypeEnum.passport;
    },
    isNationalIdOrIqama() {
      return (
        this.formModel.manager.identityTypeId == managerIdentityTypeEnum.nationalId ||
        this.formModel.manager.identityTypeId == managerIdentityTypeEnum.regularResidency
      );
    },
    isOtherIdType() {
      return !this.isNationalIdOrIqama && !!this.formModel.manager.identityTypeId;
    },
    socialIdRules() {
      return `${'required|max:50|socialId:' + this.formModel.manager.identityTypeId}`;
    },
    socialIdMask() {
      return this.isNationalRegularResidencySocialId
        ? `${this.formModel.manager.identityTypeId}#########` : '';
    },
    nameFieldsDisabled() {
      if (this.isViewMode || this.isEditMode) return true;
      if (this.isNationalIdOrIqama && this.formModel.manager.isIdentityVerified) return true;
      if (this.isOtherIdType && !this.formModel.manager.isIdentityVerified) return true;
      if (this.isOtherIdType && this.formModel.manager.isIdentityVerified && this.formModel.manager.isNameFromSystem && !this.formModel.manager.isNameDifferent) return true;
      return false;
    },
  },
  mounted() {
    this.getCountries()
      .then(() => {
        this.nationalities = this.countries;
      });
  },
  created() {
    if (!this.formModel.manager) { this.$set(this.formModel, 'manager', {}); }
  },
  methods: {
    ...mapActions(['getCountries', 'getManagerIdentityInquiry']),
    ...mapSysActions(['checkMOIPersonalInfo']),
    identityTypeChanged(value) {
      this.resetManagerVerification();
      this.$set(this.formModel.manager, 'identityNumber', null);
      if (!this.isViewMode) {
        if (value == managerIdentityTypeEnum.nationalId) {
          this.$set(this.formModel.manager, 'nationality', 1);
          this.$set(this.formModel, 'countryId', 1);
          this.nationalities = this.countries;
        } else {
          this.validating = false;
          this.$set(this.formModel, 'countryId', null);
          this.$set(this.formModel.manager, 'nationality', null);
          this.nationalities = this.countries.slice(1);
        }
      }
    },
    identityNumberChanged() {
      this.resetManagerVerification();
      const props = ['firstName', 'fatherName', 'thirdName', 'familyName', 'dateOfBirth'];
      props.forEach((prop) => { this.$set(this.formModel.manager, prop, undefined); });
    },
    resetManagerVerification() {
      this.$set(this.formModel.manager, 'isIdentityVerified', false);
      this.$set(this.formModel.manager, 'isNameFromSystem', false);
      this.$set(this.formModel.manager, 'isNameDifferent', false);
      this.$emit('managerValidated', false);
    },
    validateViaMoi() {
      const personalInfoRequest = {
        socialId: this.formModel.manager.identityNumber,
        dateOfBirth: this.formModel.manager.dateOfBirth,
        firstName: !this.formModel.manager.dateOfBirth ? this.formModel.manager.firstName : null,
      };
      this.validating = true;
      const props = ['firstName', 'fatherName', 'thirdName', 'familyName', 'nationality', 'gender'];
      props.forEach((prop) => { this.$set(this.formModel.manager, prop, undefined); });
      this.checkMOIPersonalInfo(personalInfoRequest)
        .then((personalInfo) => {
          this.toaster.success(this.local.common.verificationSucceeded, 2);
          this.$set(this.formModel.manager, 'firstName', personalInfo.firstName);
          this.$set(this.formModel.manager, 'fatherName', personalInfo.fatherName || personalInfo.grandFatherName);
          this.$set(this.formModel.manager, 'thirdName', personalInfo.thirdName || personalInfo.grandFatherName);
          this.$set(this.formModel.manager, 'familyName', personalInfo.familyName);
          this.$set(this.formModel.manager, 'nationality', personalInfo.nationality || personalInfo.nationalityCountryId);
          this.$set(this.formModel.manager, 'gender', personalInfo.gender);
          this.$set(this.formModel.manager, 'isIdentityVerified', true);
          this.$set(this.formModel.manager, 'isNameFromSystem', false);
          this.$emit('managerValidated', true);
        })
        .catch(() => {
          this.toaster.error(this.local.personInformation.checkPersonalInfoError);
          this.resetManagerVerification();
        })
        .finally(() => { this.validating = false; });
    },
    async validateViaBankruptcy() {
      this.validating = true;
      try {
        const res = await this.getManagerIdentityInquiry({
          identityNumber: this.formModel.manager.identityNumber,
          identityTypeId: this.formModel.manager.identityTypeId,
        });
        const data = res.data;
        if (data && (data.firstName || data.fullName)) {
          this.toaster.success(this.local.common.verificationSucceeded, 2);
          if (data.firstName) {
            this.$set(this.formModel.manager, 'firstName', data.firstName);
            this.$set(this.formModel.manager, 'fatherName', data.fatherName);
            this.$set(this.formModel.manager, 'thirdName', data.thirdName || data.grandFatherName);
            this.$set(this.formModel.manager, 'familyName', data.familyName);
          } else if (data.fullName) {
            const parts = (data.fullName || '').split(' ');
            this.$set(this.formModel.manager, 'firstName', parts[0] || '');
            this.$set(this.formModel.manager, 'fatherName', parts[1] || '');
            this.$set(this.formModel.manager, 'thirdName', parts[2] || '');
            this.$set(this.formModel.manager, 'familyName', parts[3] || parts.slice(3).join(' ') || '');
          }
          this.$set(this.formModel.manager, 'isIdentityVerified', true);
          this.$set(this.formModel.manager, 'isNameFromSystem', true);
          this.$set(this.formModel.manager, 'isNameDifferent', false);
          this.$emit('managerValidated', true);
        } else {
          this.$set(this.formModel.manager, 'firstName', undefined);
          this.$set(this.formModel.manager, 'fatherName', undefined);
          this.$set(this.formModel.manager, 'thirdName', undefined);
          this.$set(this.formModel.manager, 'familyName', undefined);
          this.$set(this.formModel.manager, 'isIdentityVerified', true);
          this.$set(this.formModel.manager, 'isNameFromSystem', false);
          this.$emit('managerValidated', true);
        }
      } catch (error) {
        const status = error?.response?.status;
        if (status === 404) {
          this.$set(this.formModel.manager, 'firstName', undefined);
          this.$set(this.formModel.manager, 'fatherName', undefined);
          this.$set(this.formModel.manager, 'thirdName', undefined);
          this.$set(this.formModel.manager, 'familyName', undefined);
          this.$set(this.formModel.manager, 'isIdentityVerified', true);
          this.$set(this.formModel.manager, 'isNameFromSystem', false);
          this.$emit('managerValidated', true);
        } else {
          this.toaster.error(this.local.personInformation.checkPersonalInfoError);
          this.resetManagerVerification();
        }
      } finally {
        this.validating = false;
      }
    },
    nameDifferentChanged() {
      if (this.formModel.manager.isNameDifferent) {
        this.$set(this.formModel.manager, 'firstName', this.formModel.manager.firstName);
        this.$set(this.formModel.manager, 'fatherName', this.formModel.manager.fatherName);
        this.$set(this.formModel.manager, 'thirdName', this.formModel.manager.thirdName);
        this.$set(this.formModel.manager, 'familyName', this.formModel.manager.familyName);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
